import { useState } from "react";
import { Row, Col } from "react-bootstrap";
import Header from "../Header.jsx";
import StopsUnitForm from "../header-compoents/StopsUnitForm.jsx";
import RouteMap from "../route-components/RouteMap.jsx";
import DeparturesLegend from "./DeparturesLegend.jsx";
import Status from "../Status.jsx";
import { useContextValues } from "../../context/RouteDataContext.jsx";
import RealtimeStopRow from "./RealtimeStopRow.jsx";
import RealtimeRowToggle from "./RealtimeRowToggle.jsx";

/**
 * RealtimeTable - Display all stops with collapsible non-timepoint sections
 */
export default function RealtimeContainer() {
  const { stopsRealtime: stops } = useContextValues();
  const [openGroup, setOpenGroup] = useState(null);

  const toggleGroup = (timepointId) => {
    setOpenGroup(openGroup === timepointId ? null : timepointId);
  };

  const rows = [];
  let currentGroupId = null;

  stops.forEach((stop, index) => {
    const nextStop = index < stops.length - 1 ? stops[index + 1] : null;

    // When we hit a timepoint, start a new group
    if (stop.timepoint) {
      currentGroupId = stop.ui_stop_loop_id;
    }

    const stopGroupId = currentGroupId;
    const isLastStop = index === stops.length - 1;
    const isCollapsed =
      !stop.timepoint && openGroup !== stopGroupId;

    rows.push(
      <RealtimeStopRow
        key={stop.ui_stop_loop_id}
        stop={stop}
        isCollapsed={isCollapsed}
        isLastStop={isLastStop}
      />
    );

    // Insert toggle after a timepoint if followed by non-timepoints
    if (stop.timepoint && nextStop && !nextStop.timepoint) {
      const isOpen = openGroup === stopGroupId;

      rows.push(
        <RealtimeRowToggle
          key={`toggle-${stopGroupId}`}
          isOpen={isOpen}
          onToggle={() => toggleGroup(stopGroupId)}
        />
      );
    }
  });

  return (
    <div
      className="ictapp__realtime"
    >
      <Row>
        <Col lg={8}>
          <RouteMap scope="realtime" />
          <Header scope="realtime" />
          <StopsUnitForm />
          <Row className="realtime__table my-3">
            <Col>{rows}</Col>
          </Row>
        </Col>
        <Col lg={4}>
          <DeparturesLegend />
          <Status />
        </Col>
      </Row>
    </div>
  );
}
